import Vue from "vue";
import {API_HOST} from "@/settings/server";
import $store from "@/store";
import axios from "axios";

class OrganizationService {
    constructor() {
        this.cancelTokenSource = axios.CancelToken.source();
    }

    cancelRequests() {
        this.cancelTokenSource.cancel('GET requests canceled by the user.');
        this.cancelTokenSource = axios.CancelToken.source();
    }
    getSimpleOrganizations({unitId}) {
        let params = {unitId: unitId}
        let endPoint = '/api/AdminOrganization';
        if (!$store.getters.isAdmin)
            endPoint = '/api/ModeratorOrganization'
        return Vue.axios.get(`${API_HOST}${endPoint}`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: params,
            cancelToken: this.cancelTokenSource.token,
        })
    }


    getClientOrganizations() {
        return Vue.axios.get(`${API_HOST}/api/ClientOrganizationEntity`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    // Add this to your ClientOrganizationService object
    disbandClientOrganizationGroup(id) {
        return Vue.axios.post(`${API_HOST}/api/ClientOrganizationEntity/DisbandGroup/${id}`, {}, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            }
        });
    }

    updateClientOrganization(id, payload) {
        // Format dates if they exist in the payload
        const formattedPayload = {
            ...payload,
            contractDateFrom: payload.contractDateFrom ? payload.contractDateFrom.format("YYYY-MM-DD") : null,
            contractDateTo: payload.contractDateTo ? payload.contractDateTo.format("YYYY-MM-DD") : null,
        };

        return Vue.axios.put(`${API_HOST}/api/ClientOrganizationEntity/${id}`, formattedPayload, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            }
        })
    }

    unjoinClientOrganization(id) {
        return Vue.axios.post(`${API_HOST}/api/ClientOrganizationEntity/Unjoin/${id}`, {}, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            }
        });
    }

    joinClientOrganizations(payload) {
        return Vue.axios.post(`${API_HOST}/api/ClientOrganizationEntity/Join`, payload, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            }
        });
    }

    getMailCount({unitId, inn: inn}) {
        let params = {unitId: unitId, inn: inn}
        return Vue.axios.get(`${API_HOST}/api/Organization`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: params,
            cancelToken: this.cancelTokenSource.token,
        })
    }
    getOrganizations({unitId: unitId, inn: inn, limit: limit, skip: skip, isActive: isActive}) {
        let params = {unitId: unitId, inn: inn, limit: limit, skip: skip, isActive: isActive}
        return Vue.axios.get(`${API_HOST}/api/Organization`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: params,
            cancelToken: this.cancelTokenSource.token,
        })
    }

    getOrganizationsWithoutParams() {
        return Vue.axios.get(`${API_HOST}/api/AdminOrganization`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    checkOrganization(organization) {
        return Vue.axios.get(`${API_HOST}/api/CheckOrganization`, {
            params: {
                name: organization
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    addOrganization({inn, name, address, accountNumber, mfo, phoneNumber, vatRegCode, branchCode, branchName,
                        isLtd, pinfl, contractSum, sumForMail, sumForOverPaged, userFullName, username, password, contractNumber, contractDateFrom,
                        contractDateTo, contractSignerUnitId, isActive, hasContractWithGlobalUnit}) {
        return Vue.axios.post(`${API_HOST}/api/Organization`, {
            Inn: inn,
            Name: name,
            Address: address,
            AccountNumber: accountNumber,
            Mfo: mfo,
            VatRegCode: vatRegCode,
            BranchCode: branchCode,
            BranchName:branchName,
            IsLtd: isLtd,
            Pinfl: pinfl,
            ContractSum: contractSum,
            SumForMail: sumForMail,
            SumForOverPaged: sumForOverPaged,
            PhoneNumber: phoneNumber,
            UserFullName: userFullName,
            Username: username,
            Password: password,
            ContractNumber: contractNumber,
            ContractDateFrom: contractDateFrom ? contractDateFrom.format("DD.MM.YYYY") : null,
            ContractDateTo: contractDateTo ? contractDateTo.format("DD.MM.YYYY") : null,
            ContractSignerUnitId: contractSignerUnitId,
            IsActive: isActive,
            HasContractWithGlobalUnit: hasContractWithGlobalUnit
        }, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            }
        })
    }

    editOrganization({inn, name, address, accountNumber, mfo, phoneNumber, vatRegCode, branchCode, branchName,
                         isLtd, pinfl, contractSum, sumForMail, sumForOverPaged,  contractNumber, contractDateFrom, contractDateTo, contractSignerUnitId, isActive, hasContractWithGlobalUnit}) {
        return Vue.axios.put(`${API_HOST}/api/Organization`, {
            Inn: inn,
            Name: name,
            Address: address,
            AccountNumber: accountNumber,
            Mfo: mfo,
            PhoneNumber: phoneNumber,
            VatRegCode: vatRegCode,
            BranchCode: branchCode,
            BranchName: branchName,
            IsLtd: isLtd,
            Pinfl: pinfl,
            ContractSum: contractSum,
            SumForMail: sumForMail,
            SumForOverPaged: sumForOverPaged,
            ContractNumber: contractNumber,
            ContractDateFrom: contractDateFrom ? contractDateFrom.format("DD.MM.YYYY") : null,
            ContractDateTo: contractDateTo ? contractDateTo.format("DD.MM.YYYY") : null,
            ContractSignerUnitId: contractSignerUnitId,
            IsActive: isActive,
            HasContractWithGlobalUnit: hasContractWithGlobalUnit
        }, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                inn: inn
            }
        })
    }

    delete(id) {
        let params = {id: id}
        return Vue.axios.delete(`${API_HOST}/api/Organization`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: params
        })
    }
}

export default new OrganizationService()
